<template>
    <div>
        <FieldComponent
                v-for="(field, fieldKey) in visibleFields"
                :key="fieldKey"
                ref="field"
                :consumer="consumer"
                :field="field"
                @updateValue="updateValue"
                @loading="loading" />
    </div>
</template>

<script>
    import FieldComponent from "./components/FieldComponent";
    
    export default {
        name: "GroupComponent",
        components: {FieldComponent},
        props: {
            group: {type: Object, default: () => {}},
            groupKey: {type: Number, default: 0},
            consumer: {type: Object, default: () => {}},
        },
        computed: {
            visibleFields() {
                return this.$store.fields.getVisibleFieldsForGroup(this.group.id)
            }
        },
        methods: {
            updateValue: function (fieldId, value) {
                this.$emit('updateValue', this.group.id, fieldId, value);
            },
            loading: function (value) {
                this.$emit('loading', value)
            },
            async validate() {
                const promises = [];
                await this.$nextTick()
                this.$refs.field.forEach(field => promises.push(field.validate()))
                return Promise.all(promises)
            },
        }
    }
</script>

<style scoped>

</style>